import TextCurrency from '@atoms/TextCurrency';
import { Text, View } from '@components/primitives';
import colors from '@theme/colors';
import { getDateInFormatLocale } from '@utils/dateUtils';
import { verticalScale } from '@utils/normalize';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import styles from './styles';

interface Item {
  key: string;
  value: string | { subKey: string; index: number; innerKey: string };
  valueFromApi: boolean;
  isCurrency?: boolean;
}

interface BPReqData {
  [key: string]: any;
  [key: number]: any;
}

interface Props {
  bpReqData: BPReqData;
  [key: string]: any;
}

export function shouldFormat(bpReqData: BPReqData, item: Item): string {
  if (item?.value && bpReqData[item.value as string]) {
    return bpReqData[item.value as string];
  }
  return '';
}

export function getValueFromAPIOrProps(item: Item, props: Props): string {
  if (item.valueFromApi && typeof item.value === 'string') {
    return shouldFormat(props.bpReqData, item);
  }
  if (item.valueFromApi && typeof item.value === 'object') {
    const { bpReqData } = props;
    const key = item.value;
    if (bpReqData && bpReqData[key.subKey]) {
      if (bpReqData[key.subKey][key.index] && bpReqData[key.subKey][key.index][key.innerKey]) {
        return bpReqData[key.subKey][key.index][key.innerKey];
      }
      return '';
    }
    return '';
  }
  if (!item.valueFromApi) {
    return props[item.value as string] ?? '';
  }
  return '';
}

function getKeyFromConfig(t: (key: string) => string, item: Item, isSummary = false): React.JSX.Element {
  return (
    <Text testID={`detail_${item.key}`} variant={isSummary ? 'sm-bold' : 'sm-normal'} flex={1}>
      {t(`reqTxSheet.${item.key}`)}
    </Text>
  );
}

function getValuesFromProductConfig(item: Item, props: Props, isSummary = false): React.JSX.Element {
  return item.isCurrency ? (
    <TextCurrency
      variant="sm-bold"
      testID="txtCurrencyNominal"
      suffix={null}
      color={isSummary ? colors.success.cactus : colors.neutral.charcoal}
      amountCurrency={getValueFromAPIOrProps(item, props)}
    />
  ) : (
    <Text
      textAlign="right"
      flex={1}
      testID="txtCurrencyNominal"
      variant="sm-bold"
      color={isSummary ? colors.success.cactus : colors.neutral.charcoal}>
      {getValueFromAPIOrProps(item, props)}
    </Text>
  );
}

interface ConfigArrayProps {
  configArray: Item[];
  t: (key: string) => string;
  props: Props;
  isSummary?: boolean;
}

export function showProdDetailsFromConfigAndApi({
  configArray,
  t,
  props,
  isSummary = false,
}: ConfigArrayProps): React.JSX.Element {
  return (
    <View style={{ marginTop: verticalScale(8) }}>
      {configArray.map(item => (
        <View key={item.key} style={styles.detailsStyle as StyleProp<ViewStyle>}>
          {getKeyFromConfig(t, item, isSummary)}
          {getValuesFromProductConfig(item, props, isSummary)}
        </View>
      ))}
    </View>
  );
}
